import {FontSize} from '../Constants';

export const BaseResidentTheme = {
    fontSize: {
        ExtraBig: FontSize.ExtraBig,
        Big: FontSize.Big,
        Accent: FontSize.Accent,
        Body: FontSize.Body,
        Middle: FontSize.Middle,
        Small: FontSize.Small,
    },
};

export const BaseResidentThemeForAdmin = {
    fontSize: {
        ExtraBig: `calc(${FontSize.ExtraBig} / 1.6)`,
        Big: `calc(${FontSize.Big} / 1.6)`,
        Accent: `calc(${FontSize.Accent} / 1.6)`,
        Body: `calc(${FontSize.Body} / 1.6)`,
        Middle: `calc(${FontSize.Middle} / 1.6)`,
        Small: `calc(${FontSize.Small} / 1.6)`,
    },
};